import { useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { useBffClient } from './useBffClient';

export interface UpdateCommunicationPreferencesRequest {
  patient_id: string;
  preferred_language: string;
}

/**
 * Hook to update a patient's communication preferences
 * This updates the patient's preferred language for communications
 */
export const useUpdateCommunicationPreferences = () => {
  const authClient = useBffClient();
  return useMutation<void, AxiosError, UpdateCommunicationPreferencesRequest>(
    async requestBody => {
      const response = await authClient.post('/patients/communication_preferences', requestBody);
      return response.data;
    },
    {
      retry: false,
    }
  );
};
